export default __webpack_public_path__ + "static/media/img-features-dot.490a2219.svg";